import { Activity } from "lucide-react";
import { type QuizConfig } from "~/types/quiz";

export const emocijalnaInteligencija: QuizConfig = {
  id: "emocionalna-inteligencija",
  illustration: {
    src: "/images/quizzes/emocionalna-inteligencija.webp",
    alt: "Muškarac zastaje tokom razgovora i obraća pažnju na svoja osećanja.",
  },
  lastModified: "2026-07-18",
  title: "Koliko dobro razumeš svoje emocije?",
  shortTitle: "Emocionalna inteligencija",
  description:
    "Otkrij koliko dobro razumeš svoje emocije i kako se nosiš sa njima kroz ovaj kratak test.",
  longDescription:
    "Proceni kako prepoznaješ, imenuješ i izražavaš emocije kod sebe i drugih, ali i šta preduzimaš kada stvari postanu intenzivne. Test kombinuje situacione scenarije i refleksiju o svakodnevnim navikama kako bi otkrio gde ti emocionalna inteligencija najviše pomaže, a gde ti se potkradaju blokade. Na kraju dobijaš preporuke kako da razviješ empatiju, smanjiš impulsivne reakcije i unaprediš odnose kroz jasniju komunikaciju.",
  icon: Activity,
  duration: "3-5 min",
  category: "Ličnost i emocije",
  focusAreasWanted: [
    "emotional_regulation",
    "self_development",
    "communication",
    "stress",
  ],
  questions: [
    {
      type: "radio",
      question: "Koliko često si svestan/na svojih emocija dok ih doživljavaš?",
      options: ["Uvek", "Često", "Ponekad", "Retko", "Nikad"],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "radio",
      question: "Da li lako prepoznaješ zašto se osećaš na određeni način?",
      options: [
        "Da, vrlo lako",
        "Uglavnom da",
        "Ponekad",
        "Teško mi je",
        "Nikako",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question: "Koje od ovih stvari dobro radiš? (označi sve što važi)",
      options: [
        "Prepoznajem kad sam pod stresom",
        "Umem da se smirim kad sam uznemiren/a",
        "Lako razumem kako se drugi osećaju",
        "Jasno izražavam svoje emocije",
        "Retko gubim kontrolu nad emocijama",
        "Ništa od navedenog",
      ],
      scores: [1, 1, 1, 1, 1, 0],
    },
    {
      type: "radio",
      question: "Koliko često te tuđe emocije zbune ili preplave?",
      options: ["Nikad", "Retko", "Ponekad", "Često", "Uvek"],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "radio",
      question:
        "Možeš li da kontrolišeš svoje reakcije u stresnim situacijama?",
      options: ["Da, uvek", "Uglavnom da", "Ponekad", "Retko", "Nikad"],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question:
        "Kako se ponašaš kad si pod jakim emocijama? (označi sve što važi)",
      options: [
        "Povučem se i razmislim",
        "Pričam sa nekim o tome",
        "Pokušavam da se smirim",
        "Reagujem impulsivno",
        "Potiskujem emocije",
        "Tražim način da ih izrazim kreativno",
      ],
      scores: [1, 1, 1, 0, 0, 1],
    },
    {
      type: "radio",
      question: "Koliko ti je lako da prepoznaš tuđe emocije?",
      options: [
        "Vrlo lako",
        "Uglavnom lako",
        "Zavisi od situacije",
        "Često mi je teško",
        "Vrlo teško",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "textarea",
      question: "Šta ti je najveći izazov kad su u pitanju emocije?",
    },
  ],
  copy: {
    title: "Tvoja emocionalna inteligencija",
    subtitle: "Saznaj koliko dobro razumeš i upravljaš svojim emocijama",
    scoreLabel: "Tvoj rezultat testa emocionalne inteligencije:",
    adviceTitle: "Saveti za tebe",
    resourcesTitle: "Predlažemo da pročitaš:",
    whatNextTitle: "Šta dalje?",
    shareButtonText: "Podeli rezultat",
  },
};
